import React from 'react';
import { ResultItemProps } from 'components/ui/Results/ResultItem';
import ResultImage from 'shared/components/hawksearch/components/ui/Results/ResultImage';

function EmployeeResultItem({ item }: ResultItemProps) {
	//const moment = require('moment');

	const itemName = item.getDocumentValue('name');
	const url = item.getDocumentValue('url_detail');
	const title = item.getDocumentValue('employee_title');

	return (
		<div className="roc-meet-team-listing__item">
			<ResultImage item={item} />
			<h2 className="roc-meet-team-listing__item-title">
				{url ? (
					<a href={url}>
						<span>{itemName}</span>
					</a>
				) : (
					<span>{itemName}</span>
				)}
			</h2>
			{title ? <p>{title}</p> : null}
			<div
				className="roc-meet-team-listing__item-description"
				dangerouslySetInnerHTML={{ __html: item.BestFragment }}
			/>

			{url && (
				<a className="result-item__btn" href={url}>
					<span>View Bio</span>
				</a>
			)}
		</div>
	);
}

export default EmployeeResultItem;
